<template>
  <div>
    
    <main role="main">
      <div class="block">
        <p id="title" class="news-title">{{title}}</p>
        <p id="date" class="news-date mb-0">{{date}}</p>
      </div>

      <div class="row m-0 mb-3">
        <div class="col-md-8 block">
          <div id="content">{{content}}</div>
        </div>
        <div class="col-md-4 block">
        </div>
      </div>
    </main>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'News',
  data () {
    return {
      title: '',
      date: '',
      content: ''
    }
  },
  computed: {
    id () {
      console.log('ID: ', this.$route.params.id)
      return this.$route.params.id
    }
  },
  methods: {
    getNews: function () {
      var that = this

      axios.get(this.$BASE_URL + '/common/news/get/' + this.id)
        .then(function (resp) {
          console.log('axios', resp.data.data)
          that.title = resp.data.data.title
          that.date = that.formatTimestamp(resp.data.data.date)
          that.content = resp.data.data.content
        })
        .catch(function (error) {
          console.log('axios error', error)
        })
    },
    formatTimestamp: function (timestamp) {
      var a = new Date(timestamp)
      var year = a.getFullYear()
      var month = a.getMonth() + 1
      var date = a.getDate()

      return year + '-' + (parseInt(month) < 10 ? '0' + month : month) + '-' + date
    }
  },
  mounted: function () {
    this.getNews()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.news-title {
  line-height: 1.2em;
}
</style>



// WEBPACK FOOTER //
// src/components/News.vue